import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { Navigation } from './Navigation';
import { Footer } from './Footer';
import { Breadcrumb, BreadcrumbItem } from './Breadcrumb';
import { CyberBackground } from './ui/CyberBackground';
import { CookieConsent } from './CookieConsent';
import { generateBreadcrumbs, getParentPath, getParentLabel } from '../utils/breadcrumbGenerator';
import { ArrowLeft } from 'lucide-react';
interface LayoutProps {
  children: React.ReactNode;
  breadcrumbs?: BreadcrumbItem[];
  showBackButton?: boolean;
  backButtonLabel?: string;
  backButtonPath?: string;
}
export function Layout({
  children,
  breadcrumbs: customBreadcrumbs,
  showBackButton = true,
  backButtonLabel,
  backButtonPath
}: LayoutProps) {
  const location = useLocation();
  // Auto-generate breadcrumbs if not provided
  const breadcrumbs = customBreadcrumbs || generateBreadcrumbs(location.pathname);
  const shouldShowBreadcrumbs = breadcrumbs.length > 0;
  // Determine back button properties
  const parentPath = backButtonPath || getParentPath(location.pathname);
  const parentLabel = backButtonLabel || getParentLabel(location.pathname);
  const shouldShowBackButton = showBackButton && location.pathname !== '/';
  return <div className="min-h-screen text-slate-100 flex flex-col relative" data-id="element-324">
      {/* Skip to Main Content - Accessibility */}
      <a href="#main-content" className="skip-to-main" data-id="element-325">
        Skip to main content
      </a>

      <CyberBackground data-id="element-326" />
      <Navigation data-id="element-327" />

      <main id="main-content" className="flex-grow relative z-10" role="main" data-id="element-328">
        {/* Breadcrumbs and Back Button Container */}
        {(shouldShowBreadcrumbs || shouldShowBackButton) && <div className="border-b border-slate-800/50 bg-slate-950/50 backdrop-blur-sm" data-id="element-329">
            <div className="container mx-auto px-4 py-4" data-id="element-330">
              <div className="flex items-center justify-between gap-4 flex-wrap" data-id="element-331">
                {/* Breadcrumbs */}
                {shouldShowBreadcrumbs && <div className="flex-grow" data-id="element-332">
                    <Breadcrumb items={breadcrumbs} data-id="element-333" />
                  </div>}

                {/* Back Button */}
                {shouldShowBackButton && <Link to={parentPath} className="flex items-center text-sm text-slate-400 hover:text-cyan-400 transition-colors whitespace-nowrap" data-id="element-334">
                    <ArrowLeft className="h-4 w-4 mr-2" data-id="element-335" />
                    <span className="hidden sm:inline" data-id="element-336">
                      Back to {parentLabel}
                    </span>
                    <span className="sm:hidden" data-id="element-337">Back</span>
                  </Link>}
              </div>
            </div>
          </div>}

        {children}
      </main>

      <Footer data-id="element-338" />

      {/* GDPR Cookie Consent */}
      <CookieConsent data-id="element-339" />
    </div>;
}